import { createLogger } from '../utils/logger';

const logger = createLogger('environment');

// Environment configuration utilities
export const Environment = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  STAGING: 'staging',
};

export const getCurrentEnvironment = () => {
  return (
    process.env.REACT_APP_ENVIRONMENT ||
    process.env.NODE_ENV ||
    Environment.DEVELOPMENT
  );
};

export const isDevelopment = () => {
  return getCurrentEnvironment() === Environment.DEVELOPMENT;
};

export const isProduction = () => {
  return getCurrentEnvironment() === Environment.PRODUCTION;
};

export const isStaging = () => {
  return getCurrentEnvironment() === Environment.STAGING;
};

export const getConfig = () => {
  const env = getCurrentEnvironment();

  const baseConfig = {
    environment: env,
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',

    // Firebase
    firebase: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    },

    // Stripe
    stripe: {
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    },

    // Feature flags
    features: {
      enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
      enableErrorReporting:
        process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
      debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
    },
  };

  // Environment-specific overrides
  switch (env) {
    case Environment.DEVELOPMENT:
      return {
        ...baseConfig,
        features: {
          ...baseConfig.features,
          debugMode: true,
          enableAnalytics: false,
          enableErrorReporting: false,
        },
      };

    case Environment.PRODUCTION:
      return {
        ...baseConfig,
        features: {
          ...baseConfig.features,
          debugMode: false,
          enableAnalytics: true,
          enableErrorReporting: true,
        },
      };

    case Environment.STAGING:
      return {
        ...baseConfig,
        features: {
          ...baseConfig.features,
          debugMode: true,
          enableAnalytics: false,
          enableErrorReporting: true,
        },
      };

    default:
      return baseConfig;
  }
};

// Validate configuration on import
const config = getConfig();
const requiredKeys = [
  'firebase.apiKey',
  'firebase.authDomain',
  'firebase.projectId',
];

const missingKeys = requiredKeys.filter(key => {
  const keys = key.split('.');
  let value = config;
  for (const k of keys) {
    value = value?.[k];
  }
  return !value;
});

if (missingKeys.length > 0) {
  logger.warn(`Missing required configuration keys: ${missingKeys.join(', ')}`);
}

export default getConfig();
